export default __webpack_public_path__ + "static/media/bronze-medal.d6ad0d02.png";